<template>
  <template v-if="isTestSystem">
    <div class="test-system-line" />
    <div class="test-system-badge" title="Тестовая система: данные не боевые">
      <span class="test-system-badge__full">Тестовая система</span>
      <span class="test-system-badge__short">ТЕСТ</span>
    </div>
  </template>
</template>

<script>
import { TEST_SYSTEM } from "@/constants";

// Тонкая полоса по верхнему краю экрана и ярлычок по центру. Клики проходят
// сквозь них, поэтому они не мешают работать с шапкой и страницей.
export default {
  name: "TestSystemBadge",
  computed: {
    isTestSystem() {
      return TEST_SYSTEM;
    },
  },
};
</script>

<style scoped lang="scss">
.test-system-line,
.test-system-badge {
  position: fixed;
  top: 0;
  z-index: 9999;
  pointer-events: none;
  background-color: #f59e0b;
}

.test-system-line {
  left: 0;
  right: 0;
  height: 3px;
}

.test-system-badge {
  left: 50%;
  transform: translateX(-50%);
  padding: 2px 14px 3px;
  border-radius: 0 0 8px 8px;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.3px;
  white-space: nowrap;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);

  &__short {
    display: none;
  }

  // На телефоне длинная надпись наезжает на логотип в шапке.
  @media (max-width: 576px) {
    padding: 1px 10px 2px;
    font-size: 11px;

    &__full {
      display: none;
    }
    &__short {
      display: inline;
    }
  }
}
</style>
